import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type {
  MarketCardsSearchFacetValuesQuery,
  MarketCardsSearchFacetValuesQueryVariables,
  MarketCardsSearchQuery,
  MarketCardsSearchQueryVariables,
} from './__generated__/useMarketCardsSearch.graphql.ts';

export const MARKET_CARDS_SEARCH_FACET_VALUES_QUERY = gql`
  query MarketCardsSearchFacetValuesQuery(
    $field: String!
    $facetQuery: String!
    $query: String!
    $limit: Int
    $advancedFilters: String
    $refinements: [SearchRefinementInput!]!
    $onSaleOnly: Boolean
  ) {
    searchCardFacetValues(
      field: $field
      facetQuery: $facetQuery
      query: $query
      limit: $limit
      advancedFilters: $advancedFilters
      refinements: $refinements
      onSaleOnly: $onSaleOnly
    ) {
      value
      count
    }
  }
` as TypedDocumentNode<
  MarketCardsSearchFacetValuesQuery,
  MarketCardsSearchFacetValuesQueryVariables
>;

export const MARKET_CARDS_SEARCH_QUERY = gql`
  query MarketCardsSearchQuery(
    $query: String!
    $page: Int
    $pageSize: Int
    $advancedFilters: String
    $sorts: [SearchSortInput!]!
    $refinements: [SearchRefinementInput!]!
    $facets: [SearchFacetDefinitionInput!]!
    $onSaleOnly: Boolean
  ) {
    searchCards(
      query: $query
      page: $page
      pageSize: $pageSize
      sorts: $sorts
      advancedFilters: $advancedFilters
      refinements: $refinements
      facets: $facets
      onSaleOnly: $onSaleOnly
    ) {
      page
      nbPages
      nbHits
      hits {
        slug
      }
      facets {
        field
        values {
          value
          count
        }
        min {
          value
        }
        max {
          value
        }
      }
    }
  }
` as TypedDocumentNode<MarketCardsSearchQuery, MarketCardsSearchQueryVariables>;
